import { render, staticRenderFns } from "./BaseLoading.vue?vue&type=template&id=4babd990&"
import script from "./BaseLoading.vue?vue&type=script&lang=js&"
export * from "./BaseLoading.vue?vue&type=script&lang=js&"
import style0 from "./BaseLoading.vue?vue&type=style&index=0&id=4babd990&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports